/* Raw Blend: "Goes well with" add-ons, in the cart drawer (snippets/cart-drawer.liquid) and on the cart page
   (sections/main-cart-footer.liquid). Each [data-rb-recs] box names the priciest item in the cart; this asks
   Shopify for that product's complementary products first (set in the Search & Discovery app), and when there
   are none uses Shopify's related products, keeping only ones that cost at most half the item's price (trays,
   sheets, books, bottles, not a second machine). Products already in the cart are left out; the box stays
   hidden when nothing fits. Answers are cached per product.
   Drawer: Dawn re-renders the drawer's inside after every cart change, so a MutationObserver fills each new
   copy while the drawer is open; "+ Add" re-renders the drawer the way Dawn's product form does.
   Cart page: boxes marked data-rb-recs-page fill on load; "+ Add" reloads the page so every total is right.
   Loaded by both files; runs once. */
(function () {
  if (window.rbCartRecs) return;
  window.rbCartRecs = true;
  if (!window.fetch) return;
  var cache = {};

  function get(url, id, intent) {
    var key = id + ':' + intent;
    if (!cache[key]) {
      cache[key] = fetch(url + '?product_id=' + encodeURIComponent(id) + '&limit=10&intent=' + intent, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return (j && j.products) || []; })
        .catch(function () { delete cache[key]; return []; });
    }
    return cache[key];
  }
  /* the store's money format, whole dollars without ".00" (like the product cards) */
  function money(cents, format) {
    var n = cents / 100;
    var s = n % 1 === 0 ? n.toLocaleString('en-AU') : n.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var f = format || '';
    return /\{\{\s*[a-z_]+\s*\}\}/.test(f) ? f.replace(/\{\{\s*[a-z_]+\s*\}\}/, s) : '$' + s;
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function sized(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  /* one compact row per add-on: 56px photo, name + price, and an "+ Add" pill (about 72px tall) */
  function card(p, box) {
    var url = p.url || '/products/' + p.handle;
    var li = el('li', 'rb-cd-rec');
    var media = el('a', 'rb-cd-rec__media');
    media.href = url;
    media.tabIndex = -1;
    media.setAttribute('aria-hidden', 'true');
    var fi = p.featured_image || (p.images && p.images[0]);
    if (fi) {
      var im = el('img', 'rb-cd-rec__img');
      im.src = sized(fi, 120);
      im.srcset = sized(fi, 120) + ' 120w, ' + sized(fi, 180) + ' 180w';
      im.sizes = '56px';
      im.alt = '';
      im.loading = 'lazy';
      im.width = 120;
      im.height = 120;
      media.appendChild(im);
    }
    li.appendChild(media);
    var body = el('div', 'rb-cd-rec__body');
    var name = el('a', 'rb-cd-rec__name', p.title);
    name.href = url;
    body.appendChild(name);
    var price = el('p', 'rb-cd-rec__price');
    price.appendChild(el('span', 'rb-cd-rec__now', money(p.price, box.dataset.money)));
    if (p.compare_at_price > p.price) price.appendChild(el('s', 'rb-cd-rec__was', money(p.compare_at_price, box.dataset.money)));
    body.appendChild(price);
    li.appendChild(body);
    var variants = p.variants || [];
    var v = variants.filter(function (x) { return x.available; })[0];
    var btn;
    if (v && variants.length === 1) {
      btn = el('button', 'rb-cd-rec__add');
      btn.type = 'button';
      btn.setAttribute('data-rb-rec-add', v.id);
      btn.setAttribute('aria-label', box.dataset.addLabel + ': ' + p.title);
      btn.innerHTML = (box.querySelector('[data-rb-ic-add]') || {}).innerHTML || '+';
      btn.appendChild(el('span', 'rb-cd-rec__add-txt', box.dataset.addShort || '')).setAttribute('aria-hidden', 'true');
    } else {
      btn = el('a', 'rb-cd-rec__add rb-cd-rec__add--go');
      btn.href = url;
      btn.setAttribute('aria-label', box.dataset.chooseLabel + ': ' + p.title);
      btn.innerHTML = (box.querySelector('[data-rb-ic-go]') || {}).innerHTML || '&rarr;';
    }
    li.appendChild(btn);
    return li;
  }
  function usable(list, box) {
    var inCart = (box.dataset.inCart || '').split(',');
    return list.filter(function (p) { return p.available && inCart.indexOf(String(p.id)) === -1; });
  }
  function fill(box) {
    if (box.dataset.state) return;
    box.dataset.state = 'loading';
    var id = box.dataset.productId;
    var url = box.dataset.url;
    var cap = Number(box.dataset.price) * 0.5;
    get(url, id, 'complementary')
      .then(function (list) {
        list = usable(list, box);
        if (list.length) return list;
        return get(url, id, 'related').then(function (rel) {
          return usable(rel, box).filter(function (p) { return p.price <= cap; });
        });
      })
      .then(function (list) {
        list = list.slice(0, Number(box.dataset.limit) || 3);
        if (!list.length) { box.dataset.state = 'none'; return; }
        var ul = box.querySelector('.rb-cd-recs__list');
        list.forEach(function (p) { ul.appendChild(card(p, box)); });
        box.hidden = false;
        box.dataset.state = 'done';
      });
  }

  /* the drawer: fill while it is open */
  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    var scan = function () {
      if (!drawer.classList.contains('active')) return;
      drawer.querySelectorAll('[data-rb-recs]:not([data-state])').forEach(fill);
    };
    new MutationObserver(scan).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    scan();
  }
  /* the cart page */
  function scanPage() {
    document.querySelectorAll('[data-rb-recs][data-rb-recs-page]:not([data-state])').forEach(fill);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scanPage);
  else scanPage();
  document.addEventListener('shopify:section:load', scanPage);

  /* one-tap add */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('button[data-rb-rec-add]') : null;
    if (!b) return;
    var inDrawer = !!(drawer && drawer.contains(b));
    e.preventDefault();
    b.setAttribute('aria-busy', 'true');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var payload = { items: [{ id: Number(b.getAttribute('data-rb-rec-add')), quantity: 1 }] };
    if (inDrawer) {
      payload.sections = 'cart-drawer,cart-icon-bubble';
      payload.sections_url = window.location.pathname;
    }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
      .then(function (res) {
        if (!inDrawer) { window.location.reload(); return; }
        if (res.sections && typeof drawer.renderContents === 'function') drawer.renderContents(res);
        /* tell the rest of the page, as Dawn's product form does (PUB_SUB_EVENTS is a global const, not on window) */
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rb-cart-recs', productVariantId: b.getAttribute('data-rb-rec-add'), cartData: res });
        }
      })
      .catch(function () {
        /* sold out or a quantity rule: open the product instead */
        b.removeAttribute('aria-busy');
        var a = b.closest('.rb-cd-rec') && b.closest('.rb-cd-rec').querySelector('.rb-cd-rec__name');
        if (a) window.location.href = a.href;
      });
  });
})();
